import { useState, FC } from 'react'
import { ResolvedReturn } from '../../types/functions'
import { Layers, ChevronDown, ChevronRight } from 'lucide-react'

interface FunctionReturnsProps {
  returns: ResolvedReturn
}

export const FunctionReturns: FC<FunctionReturnsProps> = ({ returns }) => {
  const [expanded, setExpanded] = useState(false)
  const hasSchema = !!returns.resolvedInterface && returns.resolvedInterface.properties.length > 0

  return (
    <div className="ns-returns-section">
      <h3 className="ns-section-title">Returns</h3>

      <div className="ns-returns-card">
        <div className="ns-returns-header">
          <div className="ns-returns-type-wrap">
            <span className="ns-return-type-badge">{returns.typeString}</span>
            {hasSchema && (
              <button
                type="button"
                onClick={() => setExpanded(!expanded)}
                className="ns-schema-toggle-btn"
              >
                <Layers size={12} />
                <span>{expanded ? 'Hide Return Schema' : 'Return Schema'}</span>
                {expanded ? <ChevronDown size={12} /> : <ChevronRight size={12} />}
              </button>
            )}
          </div>
          {returns.description && (
            <div className="ns-returns-desc">{returns.description}</div>
          )}
        </div>

        {hasSchema && expanded && (
          <div className="ns-nested-schema-card" style={{ marginTop: '0.75rem' }}>
            <div className="ns-nested-schema-header">
              <Layers size={14} className="ns-nested-icon" />
              <strong>{returns.resolvedInterface!.name}</strong>
              {returns.resolvedInterface!.description && (
                <span className="ns-nested-desc">
                  — {returns.resolvedInterface!.description}
                </span>
              )}
            </div>

            <table className="ns-nested-table">
              <thead>
                <tr>
                  <th style={{ width: '28%' }}>Property</th>
                  <th style={{ width: '32%' }}>Type</th>
                  <th style={{ width: '40%' }}>Description</th>
                </tr>
              </thead>
              <tbody>
                {returns.resolvedInterface!.properties.map(prop => (
                  <tr key={prop.name}>
                    <td className="ns-prop-name-cell">
                      <span className="ns-prop-name">{prop.name}</span>
                      {prop.optional ? (
                        <span className="ns-flag-optional">optional</span>
                      ) : (
                        <span className="ns-flag-required">required</span>
                      )}
                    </td>
                    <td className="ns-prop-type-cell">
                      <span className="ns-type-badge">{prop.typeString}</span>
                    </td>
                    <td className="ns-prop-desc-cell">
                      {prop.description ? (
                        <span>{prop.description}</span>
                      ) : (
                        <span className="ns-no-desc">—</span>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
